import { CurrencyPipe } from '@angular/common';

import { ServiceLocator } from '../service-locator.service';
import { LicensePlanGroup } from './license-plan-group';
import { LicensePlanType } from './license-plan-type';

export class LicensePlan {
	public id: number;
	public name: string;
	public description: string;
	public monthlyFee: number;
	public upfrontFee: number;
	public years: number;
	public licensePlanTypeId: number;
	public licensePlanGroupId: number;
	public sortOrder: number;

	public parents: LicensePlan[];
	public children: LicensePlan[];
	public licensePlanType: LicensePlanType;
	public licensePlanGroup: LicensePlanGroup;

	public costDescription: string;

	constructor(licensePlan: LicensePlan) {
		Object.assign(this, licensePlan);

		const currencyPipe = ServiceLocator.injector.get(CurrencyPipe);
		this.costDescription = this.getCostDescription(currencyPipe);
	}

	private getCostDescription(currencyPipe: CurrencyPipe): string {
		const paymentPeriod = this.monthlyFee || (!this.monthlyFee && !this.upfrontFee) ? 'mo' : `${this.years > 1 ? this.years + '-yrs' : 'yr'}`;
		return (
			`(${currencyPipe.transform(this.monthlyFee ? this.monthlyFee : this.upfrontFee)})/${paymentPeriod}` +
			`${this.name?.includes('Sales Codes') || this.name?.includes('Agent Bundle') ? '/each set of 10' : ''}`
		);
	}
}
